export const FETCH_STARTED = 'WEATHER/FETCH_STARTED'
export const FETCH_SUCCESS = 'WEATHER/FETCH_SUCCESS'
export const FETCH_FAILURE = 'WEATHER/FETCH_FAILURE'